/* SALITRE — wishlist.js: favoritos guardados en localStorage (sin cuenta necesaria) */
(function () {
  'use strict';

  var KEY = 'salitre:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1;
  }

  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('is-active', isSaved(handle));
      btn.setAttribute('aria-pressed', isSaved(handle) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var saved = toggle(handle);
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    updateCount();
  });

  updateCount();
  syncButtons();

  window.SalitreWishlist = { getWishlist: getWishlist, isSaved: isSaved, toggle: toggle };
})();
